import { FSharpException, Record, Union } from "./fable_modules/fable-library.3.7.14/Types.js";
import { array_type, lambda_type, enum_type, uint8_type, uint32_type, class_type, record_type, option_type, bool_type, tuple_type, int32_type, list_type, float64_type, union_type } from "./fable_modules/fable-library.3.7.14/Reflection.js";
import { comparePrimitives, max, equals } from "./fable_modules/fable-library.3.7.14/Util.js";
import { length, item, ofArray } from "./fable_modules/fable-library.3.7.14/List.js";
import { Texture$reflection } from "./Model.Platform.fs.js";

export class DifficultyLevel extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["CanIPlayDaddy", "DontHurtMe", "BringEmOn", "IAmDeathIncarnate"];
    }
}

export function DifficultyLevel$reflection() {
    return union_type("App.Model.DifficultyLevel", [], DifficultyLevel, () => [[], [], [], []]);
}

export class WallRenderingResult extends Record {
    constructor(ZIndexes, WallInFrontOfPlayer, IsDoorInFrontOfPlayer, DistanceToWallInFrontOfPlayer, SpriteInFrontOfPlayerIndexOption) {
        super();
        this.ZIndexes = ZIndexes;
        this.WallInFrontOfPlayer = WallInFrontOfPlayer;
        this.IsDoorInFrontOfPlayer = IsDoorInFrontOfPlayer;
        this.DistanceToWallInFrontOfPlayer = DistanceToWallInFrontOfPlayer;
        this.SpriteInFrontOfPlayerIndexOption = SpriteInFrontOfPlayerIndexOption;
    }
}

export function WallRenderingResult$reflection() {
    return record_type("App.Model.WallRenderingResult", [], WallRenderingResult, () => [["ZIndexes", list_type(float64_type)], ["WallInFrontOfPlayer", tuple_type(int32_type, int32_type)], ["IsDoorInFrontOfPlayer", bool_type], ["DistanceToWallInFrontOfPlayer", float64_type], ["SpriteInFrontOfPlayerIndexOption", option_type(int32_type)]]);
}

export class Vector2D extends Record {
    constructor(vX, vY) {
        super();
        this.vX = vX;
        this.vY = vY;
    }
}

export function Vector2D$reflection() {
    return record_type("App.Model.Vector2D", [], Vector2D, () => [["vX", float64_type], ["vY", float64_type]]);
}

export function Vector2D__get_CrossProduct(x) {
    return new Vector2D(x.vY, -x.vX);
}

export function Vector2D_op_Subtraction_3C4D5180(a, b) {
    return new Vector2D(a.vX - b.vX, a.vY - b.vY);
}

export function Vector2D_op_Addition_3C4D5180(a, b) {
    return new Vector2D(a.vX + b.vX, a.vY + b.vY);
}

export function Vector2D_op_Multiply_Z23A8CFC1(a, b) {
    return new Vector2D(a.vX * b, a.vY * b);
}

export function Vector2D_op_Division_Z23A8CFC1(a, b) {
    return new Vector2D(a.vX / b, a.vY / b);
}

export function Vector2D__UnsquaredDistanceFrom_Z41DD997C(this$, other) {
    return ((this$.vX - other.vX) * (this$.vX - other.vX)) + ((this$.vY - other.vY) * (this$.vY - other.vY));
}

export function Vector2D__Normalize(this$) {
    const distance = Math.sqrt((this$.vX * this$.vX) + (this$.vY * this$.vY));
    return new Vector2D(this$.vX / distance, this$.vY / distance);
}

export function Vector2D__Abs(this$) {
    return new Vector2D(Math.abs(this$.vX), Math.abs(this$.vY));
}

export function Vector2D__Reverse(this$) {
    return new Vector2D(this$.vX * -1, this$.vY * -1);
}

export function Vector2D__Rotate_Z114CB6F(this$, angle) {
    const ca = Math.cos(angle);
    const sa = Math.sin(angle);
    return new Vector2D((ca * this$.vX) - (sa * this$.vY), (sa * this$.vX) + (ca * this$.vY));
}

export function Vector2D__get_StringValue(this$) {
    return `{ vX: ${this$.vX}, vY: ${this$.vY} }`;
}

export function Vector2D__IsBetween(this$, a, b) {
    if ((((a.vY * b.vX) - (a.vX * b.vY)) * ((a.vY * this$.vX) - (a.vX * this$.vY))) >= 0) {
        return (((this$.vX * b.vX) - (this$.vX * b.vY)) * ((this$.vY * a.vX) - (this$.vX * a.vY))) >= 0;
    }
    else {
        return false;
    }
}

export function Vector2D__get_Magnitude(this$) {
    return Math.sqrt((this$.vX * this$.vX) + (this$.vY * this$.vY));
}

export function Vector2D__AngleBetween_Z41DD997C(a, b) {
    return Math.acos((((a.vX * b.vX) + (a.vY * b.vY)) / Vector2D__get_Magnitude(a)) * Vector2D__get_Magnitude(b)) * 1;
}

export function Vector2D__LimitToMapUnit_1505(v, _arg1) {
    return new Vector2D((v.vX > 1) ? 1 : ((v.vX < -1) ? -1 : v.vX), (v.vY > 1) ? 1 : ((v.vY < -1) ? -1 : v.vY));
}

export function Vector2D_CreateFromMapPosition_Z3227AE51(position) {
    return new Vector2D(position[0] + 0.5, position[1] + 0.5);
}

export const Direction_north = new Vector2D(0, -1);

export const Direction_northEast = Vector2D__Normalize(new Vector2D(-1, -1));

export const Direction_east = new Vector2D(-1, 0);

export const Direction_southEast = Vector2D__Normalize(new Vector2D(-1, 1));

export const Direction_south = new Vector2D(0, 1);

export const Direction_southWest = Vector2D__Normalize(new Vector2D(1, 1));

export const Direction_west = new Vector2D(1, 0);

export const Direction_northWest = Vector2D__Normalize(new Vector2D(1, -1));

export function radiansToDegrees(r) {
    return (r * 180) / (3.141592653589793 * 1);
}

export function degreesToRadians(d) {
    return ((d * 3.141592653589793) / 180) * 1;
}

export class MapDirectionException extends FSharpException {
    constructor(Data0) {
        super();
        this.Data0 = Data0;
    }
}

export function MapDirectionException$reflection() {
    return class_type("App.Model.MapDirectionException", void 0, MapDirectionException, class_type("System.Exception"));
}

function MapDirectionException__Equals_229D3F39(this$, obj) {
    if (!equals(this$, null)) {
        if (!equals(obj, null)) {
            if (obj instanceof MapDirectionException) {
                return this$.Data0 === obj.Data0;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }
    else if (!equals(obj, null)) {
        return false;
    }
    else {
        return true;
    }
}

export class MapDirection extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["North", "NorthEast", "East", "SouthEast", "South", "SouthWest", "West", "NorthWest", "None"];
    }
}

export function MapDirection$reflection() {
    return union_type("App.Model.MapDirection", [], MapDirection, () => [[], [], [], [], [], [], [], [], []]);
}

export function MapDirection_Diagonal(a, b) {
    const matchValue = [a, b];
    let pattern_matching_result;
    if (matchValue[0].tag === 2) {
        if (matchValue[1].tag === 0) {
            pattern_matching_result = 0;
        }
        else if (matchValue[1].tag === 4) {
            pattern_matching_result = 1;
        }
        else {
            pattern_matching_result = 4;
        }
    }
    else if (matchValue[0].tag === 0) {
        if (matchValue[1].tag === 2) {
            pattern_matching_result = 0;
        }
        else if (matchValue[1].tag === 6) {
            pattern_matching_result = 3;
        }
        else {
            pattern_matching_result = 4;
        }
    }
    else if (matchValue[0].tag === 4) {
        if (matchValue[1].tag === 2) {
            pattern_matching_result = 1;
        }
        else if (matchValue[1].tag === 6) {
            pattern_matching_result = 2;
        }
        else {
            pattern_matching_result = 4;
        }
    }
    else if (matchValue[0].tag === 6) {
        if (matchValue[1].tag === 4) {
            pattern_matching_result = 2;
        }
        else if (matchValue[1].tag === 0) {
            pattern_matching_result = 3;
        }
        else {
            pattern_matching_result = 4;
        }
    }
    else {
        pattern_matching_result = 4;
    }
    switch (pattern_matching_result) {
        case 0: {
            return new MapDirection(1);
        }
        case 1: {
            return new MapDirection(3);
        }
        case 2: {
            return new MapDirection(5);
        }
        case 3: {
            return new MapDirection(7);
        }
        case 4: {
            throw (new MapDirectionException(`No diagonal for ${a},${b}`));
        }
    }
}

export function MapDirection__ToDelta(x) {
    switch (x.tag) {
        case 1: {
            return [-1, -1];
        }
        case 2: {
            return [-1, 0];
        }
        case 3: {
            return [-1, 1];
        }
        case 4: {
            return [0, 1];
        }
        case 5: {
            return [1, 1];
        }
        case 6: {
            return [1, 0];
        }
        case 7: {
            return [1, -1];
        }
        case 8: {
            return [0, 0];
        }
        default: {
            return [0, -1];
        }
    }
}

export function MapDirection__ToVector(x) {
    switch (x.tag) {
        case 1: {
            return Direction_northEast;
        }
        case 2: {
            return Direction_east;
        }
        case 3: {
            return Direction_southEast;
        }
        case 4: {
            return Direction_south;
        }
        case 5: {
            return Direction_southWest;
        }
        case 6: {
            return Direction_west;
        }
        case 7: {
            return Direction_northWest;
        }
        case 8: {
            return void 0;
        }
        default: {
            return Direction_north;
        }
    }
}

export function MapDirection__Reverse(x) {
    switch (x.tag) {
        case 1: {
            return new MapDirection(5);
        }
        case 2: {
            return new MapDirection(6);
        }
        case 3: {
            return new MapDirection(7);
        }
        case 4: {
            return new MapDirection(0);
        }
        case 5: {
            return new MapDirection(1);
        }
        case 6: {
            return new MapDirection(2);
        }
        case 7: {
            return new MapDirection(3);
        }
        case 8: {
            return new MapDirection(8);
        }
        default: {
            return new MapDirection(4);
        }
    }
}

export class Side extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["NorthSouth", "EastWest"];
    }
}

export function Side$reflection() {
    return union_type("App.Model.Side", [], Side, () => [[], []]);
}

export class Wall extends Record {
    constructor(NorthSouthTextureIndex, EastWestTextureIndex) {
        super();
        this.NorthSouthTextureIndex = (NorthSouthTextureIndex | 0);
        this.EastWestTextureIndex = (EastWestTextureIndex | 0);
    }
}

export function Wall$reflection() {
    return record_type("App.Model.Wall", [], Wall, () => [["NorthSouthTextureIndex", int32_type], ["EastWestTextureIndex", int32_type]]);
}

export function Wall__get_IsExit(this$) {
    if (((this$.NorthSouthTextureIndex === 40) ? true : (this$.EastWestTextureIndex === 40)) ? true : (this$.NorthSouthTextureIndex === 41)) {
        return true;
    }
    else {
        return this$.EastWestTextureIndex === 41;
    }
}

export class SoundEffect extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["UttGuards", "Dog", "DoorClose", "DoorOpen", "PlayerMachineGun", "PlayerPistol", "PlayerChainGun", "Hoofafo", "GutenTag", "Mutti", "GuardChainGun", "GuardMachineGun", "Aarggh", "Aieeee", "Ooof", "SecretDoor", "MeinLeben", "GuardPistol", "BubblesQuestion", "VictoryYeah", "Tick"];
    }
}

export function SoundEffect$reflection() {
    return union_type("App.Model.SoundEffect", [], SoundEffect, () => [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []]);
}

export function SoundEffect_get_All() {
    return ofArray([new SoundEffect(0), new SoundEffect(1), new SoundEffect(2), new SoundEffect(3), new SoundEffect(4), new SoundEffect(5), new SoundEffect(6), new SoundEffect(7), new SoundEffect(8), new SoundEffect(9), new SoundEffect(10), new SoundEffect(11), new SoundEffect(12), new SoundEffect(13), new SoundEffect(14), new SoundEffect(15), new SoundEffect(16), new SoundEffect(17), new SoundEffect(18), new SoundEffect(19), new SoundEffect(20)]);
}

export class DoorDirection extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["NorthSouth", "EastWest"];
    }
}

export function DoorDirection$reflection() {
    return union_type("App.Model.DoorDirection", [], DoorDirection, () => [[], []]);
}

export class DoorStatus extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Opening", "Closing", "Open", "Closed"];
    }
}

export function DoorStatus$reflection() {
    return union_type("App.Model.DoorStatus", [], DoorStatus, () => [[], [], [], []]);
}

export class DoorState extends Record {
    constructor(TextureIndex, DoorDirection, Status, Offset, TimeRemainingInAnimationState, MapPosition, AreaOne, AreaTwo) {
        super();
        this.TextureIndex = (TextureIndex | 0);
        this.DoorDirection = DoorDirection;
        this.Status = Status;
        this.Offset = Offset;
        this.TimeRemainingInAnimationState = TimeRemainingInAnimationState;
        this.MapPosition = MapPosition;
        this.AreaOne = (AreaOne | 0);
        this.AreaTwo = (AreaTwo | 0);
    }
}

export function DoorState$reflection() {
    return record_type("App.Model.DoorState", [], DoorState, () => [["TextureIndex", int32_type], ["DoorDirection", DoorDirection$reflection()], ["Status", DoorStatus$reflection()], ["Offset", float64_type], ["TimeRemainingInAnimationState", float64_type], ["MapPosition", tuple_type(int32_type, int32_type)], ["AreaOne", int32_type], ["AreaTwo", int32_type]]);
}

export class Cell extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Wall", "Door", "TurningPoint", "Empty"];
    }
}

export function Cell$reflection() {
    return union_type("App.Model.Cell", [], Cell, () => [[["Item", Wall$reflection()]], [["Item", int32_type]], [["Item", MapDirection$reflection()]], []]);
}

export class EnemyType extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Guard", "Officer", "SS", "Dog", "Zombie", "FakeAdolf", "Adolf", "Fettgesicht", "Schabbs", "Gretel", "Hans", "Otto", "Ghost"];
    }
}

export function EnemyType$reflection() {
    return union_type("App.Model.EnemyType", [], EnemyType, () => [[], [], [], [], [], [], [], [], [], [], [], [], []]);
}

export class PathState extends Record {
    constructor(TargetX, TargetY, ChaseOnTargetReached) {
        super();
        this.TargetX = (TargetX | 0);
        this.TargetY = (TargetY | 0);
        this.ChaseOnTargetReached = ChaseOnTargetReached;
    }
}

export function PathState$reflection() {
    return record_type("App.Model.PathState", [], PathState, () => [["TargetX", int32_type], ["TargetY", int32_type], ["ChaseOnTargetReached", bool_type]]);
}

export function PathState_get_Empty() {
    return new PathState(-1, -1, false);
}

export class EnemyStateType extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Standing", "Ambushing", "Attack", "Path", "Pain", "Shoot", "Chase", "Die", "Dead"];
    }
}

export function EnemyStateType$reflection() {
    return union_type("App.Model.EnemyStateType", [], EnemyStateType, () => [[], [], [], [["Item", PathState$reflection()]], [["Item", EnemyStateType$reflection()]], [], [["Item1", int32_type], ["Item2", int32_type]], [], []]);
}

export class BasicGameObject extends Record {
    constructor(Position, PlayerRelativePosition, UnsquaredDistanceFromPlayer, SpriteIndex, CollidesWithBullets, Pickupable, HitpointsRestored, AmmoRestored, LivesRestored, Score, Blocking) {
        super();
        this.Position = Position;
        this.PlayerRelativePosition = PlayerRelativePosition;
        this.UnsquaredDistanceFromPlayer = UnsquaredDistanceFromPlayer;
        this.SpriteIndex = (SpriteIndex | 0);
        this.CollidesWithBullets = CollidesWithBullets;
        this.Pickupable = Pickupable;
        this.HitpointsRestored = (HitpointsRestored | 0);
        this.AmmoRestored = (AmmoRestored | 0);
        this.LivesRestored = (LivesRestored | 0);
        this.Score = (Score | 0);
        this.Blocking = Blocking;
    }
}

export function BasicGameObject$reflection() {
    return record_type("App.Model.BasicGameObject", [], BasicGameObject, () => [["Position", Vector2D$reflection()], ["PlayerRelativePosition", Vector2D$reflection()], ["UnsquaredDistanceFromPlayer", float64_type], ["SpriteIndex", int32_type], ["CollidesWithBullets", bool_type], ["Pickupable", bool_type], ["HitpointsRestored", int32_type], ["AmmoRestored", int32_type], ["LivesRestored", int32_type], ["Score", int32_type], ["Blocking", bool_type]]);
}

export function BasicGameObject__get_MapPosition(this$) {
    return [~(~this$.Position.vX), ~(~this$.Position.vY)];
}

export class Enemy extends Record {
    constructor(EnemyType, BasicGameObject, Direction, DeathSpriteIndexes, AttackSpriteIndexes, SpriteBlocks, FramesPerBlock, CurrentAnimationFrame, TimeUntilNextAnimationFrame, State, IsFirstAttack, FireAtPlayerRequired, MoveToChaseRequired, HitPoints, HurtSpriteIndex, PatrolSpeed, ChaseSpeed) {
        super();
        this.EnemyType = EnemyType;
        this.BasicGameObject = BasicGameObject;
        this.Direction = Direction;
        this.DeathSpriteIndexes = DeathSpriteIndexes;
        this.AttackSpriteIndexes = AttackSpriteIndexes;
        this.SpriteBlocks = (SpriteBlocks | 0);
        this.FramesPerBlock = (FramesPerBlock | 0);
        this.CurrentAnimationFrame = (CurrentAnimationFrame | 0);
        this.TimeUntilNextAnimationFrame = TimeUntilNextAnimationFrame;
        this.State = State;
        this.IsFirstAttack = IsFirstAttack;
        this.FireAtPlayerRequired = FireAtPlayerRequired;
        this.MoveToChaseRequired = MoveToChaseRequired;
        this.HitPoints = (HitPoints | 0);
        this.HurtSpriteIndex = (HurtSpriteIndex | 0);
        this.PatrolSpeed = PatrolSpeed;
        this.ChaseSpeed = ChaseSpeed;
    }
}

export function Enemy$reflection() {
    return record_type("App.Model.Enemy", [], Enemy, () => [["EnemyType", EnemyType$reflection()], ["BasicGameObject", BasicGameObject$reflection()], ["Direction", MapDirection$reflection()], ["DeathSpriteIndexes", list_type(int32_type)], ["AttackSpriteIndexes", list_type(int32_type)], ["SpriteBlocks", int32_type], ["FramesPerBlock", int32_type], ["CurrentAnimationFrame", int32_type], ["TimeUntilNextAnimationFrame", float64_type], ["State", EnemyStateType$reflection()], ["IsFirstAttack", bool_type], ["FireAtPlayerRequired", bool_type], ["MoveToChaseRequired", bool_type], ["HitPoints", int32_type], ["HurtSpriteIndex", int32_type], ["PatrolSpeed", float64_type], ["ChaseSpeed", float64_type]]);
}

export function Enemy__get_DirectionVector(this$) {
    return MapDirection__ToVector(this$.Direction);
}

export function Enemy__get_StationarySpriteBlockIndex(this$) {
    return this$.BasicGameObject.SpriteIndex;
}

export function Enemy__MovementSpriteBlockIndex_Z524259A4(this$, frame) {
    return this$.BasicGameObject.SpriteIndex + (frame * this$.FramesPerBlock);
}

export function Enemy__get_NumberOfMovementAnimationFrames(this$) {
    return this$.SpriteBlocks - 1;
}

export function Enemy__get_IsAlive(this$) {
    const matchValue = this$.State;
    switch (matchValue.tag) {
        case 8:
        case 7: {
            return false;
        }
        default: {
            return true;
        }
    }
}

export function Enemy__get_BaseSpriteIndexForState(this$) {
    const matchValue = this$.State;
    switch (matchValue.tag) {
        case 0: {
            return Enemy__get_StationarySpriteBlockIndex(this$) | 0;
        }
        case 6:
        case 3: {
            return Enemy__MovementSpriteBlockIndex_Z524259A4(this$, this$.CurrentAnimationFrame) | 0;
        }
        case 2: {
            return item(this$.CurrentAnimationFrame, this$.AttackSpriteIndexes) | 0;
        }
        case 4: {
            return this$.HurtSpriteIndex | 0;
        }
        default: {
            return this$.BasicGameObject.SpriteIndex | 0;
        }
    }
}

export function Enemy_AnimationTimeForState_4C3F69DE(state) {
    switch (state.tag) {
        case 2: {
            return 200;
        }
        case 6: {
            return 100;
        }
        case 3: {
            return 300;
        }
        case 4: {
            return 100;
        }
        case 8:
        case 7: {
            return 100;
        }
        default: {
            return 0;
        }
    }
}

export function Enemy__get_SpriteIndexForAnimationFrame(this$) {
    const matchValue = this$.State;
    switch (matchValue.tag) {
        case 2: {
            return item(this$.CurrentAnimationFrame, this$.AttackSpriteIndexes) | 0;
        }
        case 8:
        case 7: {
            return item(this$.CurrentAnimationFrame, this$.DeathSpriteIndexes) | 0;
        }
        default: {
            return Enemy__get_StationarySpriteBlockIndex(this$) | 0;
        }
    }
}

export function Enemy__get_AnimationFrames(this$) {
    const matchValue = this$.State;
    switch (matchValue.tag) {
        case 2: {
            return length(this$.AttackSpriteIndexes) | 0;
        }
        case 8:
        case 7: {
            return length(this$.DeathSpriteIndexes) | 0;
        }
        default: {
            return 1;
        }
    }
}

export function Enemy__get_IsBoss(this$) {
    const matchValue = this$.EnemyType;
    switch (matchValue.tag) {
        case 0:
        case 1:
        case 3:
        case 2:
        case 4: {
            return false;
        }
        default: {
            return true;
        }
    }
}

export function Enemy__get_IsVisible(this$) {
    return true;
}

export class WeaponType extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Knife", "Pistol", "MachineGun", "ChainGun"];
    }
}

export function WeaponType$reflection() {
    return union_type("App.Model.WeaponType", [], WeaponType, () => [[], [], [], []]);
}

export class PlayerWeapon extends Record {
    constructor(Sprites, CurrentFrame, Damage, AutoRepeat, RequiresAmmunition, StatusBarImageIndex, WeaponType) {
        super();
        this.Sprites = Sprites;
        this.CurrentFrame = (CurrentFrame | 0);
        this.Damage = (Damage | 0);
        this.AutoRepeat = AutoRepeat;
        this.RequiresAmmunition = RequiresAmmunition;
        this.StatusBarImageIndex = (StatusBarImageIndex | 0);
        this.WeaponType = WeaponType;
    }
}

export function PlayerWeapon$reflection() {
    return record_type("App.Model.PlayerWeapon", [], PlayerWeapon, () => [["Sprites", list_type(Texture$reflection())], ["CurrentFrame", int32_type], ["Damage", int32_type], ["AutoRepeat", bool_type], ["RequiresAmmunition", bool_type], ["StatusBarImageIndex", int32_type], ["WeaponType", WeaponType$reflection()]]);
}

export function PlayerWeapon__get_AnimationFrames(x) {
    return length(x.Sprites);
}

export function PlayerWeapon__get_CurrentSprite(x) {
    return item(x.CurrentFrame, x.Sprites);
}

export class GameObject extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Static", "Enemy"];
    }
}

export function GameObject$reflection() {
    return union_type("App.Model.GameObject", [], GameObject, () => [[["Item", BasicGameObject$reflection()]], [["Item", Enemy$reflection()]]]);
}

export function GameObject__get_BasicGameObject(x) {
    if (x.tag === 1) {
        return x.fields[0].BasicGameObject;
    }
    else {
        return x.fields[0];
    }
}

export function GameObject__UpdateBasicGameObject_6358EEEA(x, go) {
    if (x.tag === 1) {
        const e = x.fields[0];
        return new GameObject(1, new Enemy(e.EnemyType, go, e.Direction, e.DeathSpriteIndexes, e.AttackSpriteIndexes, e.SpriteBlocks, e.FramesPerBlock, e.CurrentAnimationFrame, e.TimeUntilNextAnimationFrame, e.State, e.IsFirstAttack, e.FireAtPlayerRequired, e.MoveToChaseRequired, e.HitPoints, e.HurtSpriteIndex, e.PatrolSpeed, e.ChaseSpeed));
    }
    else {
        return new GameObject(0, go);
    }
}

export class Player extends Record {
    constructor(Score, Lives, Health, Radius, CurrentWeaponIndex, Ammunition, Weapons, CurrentFaceIndex, TimeToFaceChangeMs) {
        super();
        this.Score = (Score | 0);
        this.Lives = (Lives | 0);
        this.Health = (Health | 0);
        this.Radius = Radius;
        this.CurrentWeaponIndex = (CurrentWeaponIndex | 0);
        this.Ammunition = (Ammunition | 0);
        this.Weapons = Weapons;
        this.CurrentFaceIndex = (CurrentFaceIndex | 0);
        this.TimeToFaceChangeMs = TimeToFaceChangeMs;
    }
}

export function Player$reflection() {
    return record_type("App.Model.Player", [], Player, () => [["Score", int32_type], ["Lives", int32_type], ["Health", int32_type], ["Radius", float64_type], ["CurrentWeaponIndex", int32_type], ["Ammunition", int32_type], ["Weapons", list_type(PlayerWeapon$reflection())], ["CurrentFaceIndex", int32_type], ["TimeToFaceChangeMs", float64_type]]);
}

export function Player__get_CurrentWeapon(this$) {
    return item(this$.CurrentWeaponIndex, this$.Weapons);
}

export class Camera extends Record {
    constructor(Position, Direction, Plane, FieldOfView) {
        super();
        this.Position = Position;
        this.Direction = Direction;
        this.Plane = Plane;
        this.FieldOfView = FieldOfView;
    }
}

export function Camera$reflection() {
    return record_type("App.Model.Camera", [], Camera, () => [["Position", Vector2D$reflection()], ["Direction", Vector2D$reflection()], ["Plane", Vector2D$reflection()], ["FieldOfView", float64_type]]);
}

export class SpriteLayout extends Record {
    constructor(Offset, FirstColumn, LastColumn, PixelPoolOffset) {
        super();
        this.Offset = Offset;
        this.FirstColumn = FirstColumn;
        this.LastColumn = LastColumn;
        this.PixelPoolOffset = PixelPoolOffset;
    }
}

export function SpriteLayout$reflection() {
    return record_type("App.Model.SpriteLayout", [], SpriteLayout, () => [["Offset", uint32_type], ["FirstColumn", uint32_type], ["LastColumn", uint32_type], ["PixelPoolOffset", uint32_type]]);
}

export class RawMap extends Record {
    constructor(MapSize, Plane0, Plane1, Plane2) {
        super();
        this.MapSize = (MapSize | 0);
        this.Plane0 = Plane0;
        this.Plane1 = Plane1;
        this.Plane2 = Plane2;
    }
}

export function RawMap$reflection() {
    return record_type("App.Model.RawMap", [], RawMap, () => [["MapSize", int32_type], ["Plane0", class_type("Fable.Core.JS.DataView")], ["Plane1", class_type("Fable.Core.JS.DataView")], ["Plane2", class_type("Fable.Core.JS.DataView")]]);
}

export class WolfensteinMap extends Record {
    constructor(Width, Height, Map$, Areas, NumberOfAreas, GameObjects, PlayerStartingPosition, Doors) {
        super();
        this.Width = (Width | 0);
        this.Height = (Height | 0);
        this.Map = Map$;
        this.Areas = Areas;
        this.NumberOfAreas = (NumberOfAreas | 0);
        this.GameObjects = GameObjects;
        this.PlayerStartingPosition = PlayerStartingPosition;
        this.Doors = Doors;
    }
}

export function WolfensteinMap$reflection() {
    return record_type("App.Model.WolfensteinMap", [], WolfensteinMap, () => [["Width", int32_type], ["Height", int32_type], ["Map", list_type(list_type(Cell$reflection()))], ["Areas", list_type(list_type(int32_type))], ["NumberOfAreas", int32_type], ["GameObjects", list_type(GameObject$reflection())], ["PlayerStartingPosition", Camera$reflection()], ["Doors", list_type(DoorState$reflection())]]);
}

export class OverlayAnimation extends Record {
    constructor(Red, Green, Blue, Opacity, MaxOpacity, OpacityDelta, FrameLength, TimeRemainingUntilNextFrame) {
        super();
        this.Red = Red;
        this.Green = Green;
        this.Blue = Blue;
        this.Opacity = Opacity;
        this.MaxOpacity = MaxOpacity;
        this.OpacityDelta = OpacityDelta;
        this.FrameLength = FrameLength;
        this.TimeRemainingUntilNextFrame = TimeRemainingUntilNextFrame;
    }
}

export function OverlayAnimation$reflection() {
    return record_type("App.Model.OverlayAnimation", [], OverlayAnimation, () => [["Red", uint8_type], ["Green", uint8_type], ["Blue", uint8_type], ["Opacity", float64_type], ["MaxOpacity", float64_type], ["OpacityDelta", float64_type], ["FrameLength", float64_type], ["TimeRemainingUntilNextFrame", float64_type]]);
}

export function OverlayAnimation_WithColor(red, green, blue, maxOpacity) {
    const maxOpacity_1 = max(comparePrimitives, maxOpacity, 0.2);
    const totalFrames = 10;
    const opacityDelta = maxOpacity_1 / (totalFrames / 2);
    const frameLength = 75 / totalFrames;
    return new OverlayAnimation(red, green, blue, opacityDelta, maxOpacity_1, opacityDelta, frameLength, frameLength);
}

export function OverlayAnimation_Blood_5E38073B(maxOpacity) {
    return OverlayAnimation_WithColor(255, 0, 0, maxOpacity);
}

export function OverlayAnimation_get_Pickup() {
    return OverlayAnimation_WithColor(255, 215, 0, 0.4);
}

export class ViewportFilter extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["None", "Overlay"];
    }
}

export function ViewportFilter$reflection() {
    return union_type("App.Model.ViewportFilter", [], ViewportFilter, () => [[], [["Item", OverlayAnimation$reflection()]]]);
}

export class CompositeArea extends Record {
    constructor(Area, ConnectedTo) {
        super();
        this.Area = (Area | 0);
        this.ConnectedTo = ConnectedTo;
    }
}

export function CompositeArea$reflection() {
    return record_type("App.Model.CompositeArea", [], CompositeArea, () => [["Area", int32_type], ["ConnectedTo", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [int32_type])]]);
}

export class PixelDissolverState extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Forwards", "Backwards", "Transitioning", "Stopped"];
    }
}

export function PixelDissolverState$reflection() {
    return union_type("App.Model.PixelDissolverState", [], PixelDissolverState, () => [[], [], [], []]);
}

export class PixelDissolver extends Record {
    constructor(RemainingPixels, DrawnPixels, PixelSize, PauseTimeRemaining, DissolverState) {
        super();
        this.RemainingPixels = RemainingPixels;
        this.DrawnPixels = DrawnPixels;
        this.PixelSize = PixelSize;
        this.PauseTimeRemaining = PauseTimeRemaining;
        this.DissolverState = DissolverState;
    }
}

export function PixelDissolver$reflection() {
    return record_type("App.Model.PixelDissolver", [], PixelDissolver, () => [["RemainingPixels", list_type(tuple_type(int32_type, int32_type))], ["DrawnPixels", list_type(tuple_type(int32_type, int32_type))], ["PixelSize", float64_type], ["PauseTimeRemaining", float64_type], ["DissolverState", PixelDissolverState$reflection()]]);
}

export function PixelDissolver__get_TotalPixels(this$) {
    return length(this$.RemainingPixels) + length(this$.DrawnPixels);
}

export function PixelDissolver__get_IsComplete(this$) {
    if (equals(this$.DissolverState, new PixelDissolverState(1))) {
        return length(this$.DrawnPixels) === 0;
    }
    else {
        return false;
    }
}

export class Game extends Record {
    constructor(Level, Map$, Areas, CompositeAreas, GameObjects, Player, Camera, ControlState, IsFiring, TimeToNextWeaponFrame, Doors, ViewportFilter, PixelDissolver, ResetLevel) {
        super();
        this.Level = (Level | 0);
        this.Map = Map$;
        this.Areas = Areas;
        this.CompositeAreas = CompositeAreas;
        this.GameObjects = GameObjects;
        this.Player = Player;
        this.Camera = Camera;
        this.ControlState = (ControlState | 0);
        this.IsFiring = IsFiring;
        this.TimeToNextWeaponFrame = TimeToNextWeaponFrame;
        this.Doors = Doors;
        this.ViewportFilter = ViewportFilter;
        this.PixelDissolver = PixelDissolver;
        this.ResetLevel = ResetLevel;
    }
}

export function Game$reflection() {
    return record_type("App.Model.Game", [], Game, () => [["Level", int32_type], ["Map", list_type(list_type(Cell$reflection()))], ["Areas", list_type(list_type(int32_type))], ["CompositeAreas", list_type(CompositeArea$reflection())], ["GameObjects", list_type(GameObject$reflection())], ["Player", Player$reflection()], ["Camera", Camera$reflection()], ["ControlState", enum_type("App.Model.ControlState", int32_type, [["None", 0], ["Forward", 1], ["TurningLeft", 2], ["TurningRight", 4], ["StrafingLeft", 8], ["StrafingRight", 16], ["Backward", 32], ["Fire", 64], ["Action", 128], ["Weapon0", 256], ["Weapon1", 512], ["Weapon2", 1024], ["Weapon3", 2048]])], ["IsFiring", bool_type], ["TimeToNextWeaponFrame", option_type(float64_type)], ["Doors", list_type(DoorState$reflection())], ["ViewportFilter", ViewportFilter$reflection()], ["PixelDissolver", option_type(PixelDissolver$reflection())], ["ResetLevel", lambda_type(Game$reflection(), lambda_type(Player$reflection(), Game$reflection()))]]);
}

export function Game__get_PlayerMapPosition(this$) {
    return [~(~this$.Camera.Position.vX), ~(~this$.Camera.Position.vY)];
}

export function Game__get_IsPlayerRunning(this$) {
    return (this$.ControlState & 1) === 1;
}

export class StatusBarGraphics extends Record {
    constructor(Background, HealthFaces, Dead, GrinFace, GreyFace, Font, Weapons) {
        super();
        this.Background = Background;
        this.HealthFaces = HealthFaces;
        this.Dead = Dead;
        this.GrinFace = GrinFace;
        this.GreyFace = GreyFace;
        this.Font = Font;
        this.Weapons = Weapons;
    }
}

export function StatusBarGraphics$reflection() {
    return record_type("App.Model.StatusBarGraphics", [], StatusBarGraphics, () => [["Background", Texture$reflection()], ["HealthFaces", array_type(array_type(Texture$reflection()))], ["Dead", Texture$reflection()], ["GrinFace", Texture$reflection()], ["GreyFace", Texture$reflection()], ["Font", array_type(Texture$reflection())], ["Weapons", array_type(Texture$reflection())]]);
}

export const textureWidth = 64;

export const textureHeight = 64;

export const firingTolerance = 40;

export const attackAnimationFrameTime = 200;

